export default __webpack_public_path__ + "static/media/salad.1c6cb1f6.png";